export enum filterKeys {
  contractId = 'contractId',
  campaignId = 'campaignId',
  startAmount = 'startAmount',
  endAmount = 'endAmount',
  type = 'type',
  status = 'status',
  operatorId = 'operatorId',
  paymentType = 'paymentType',
  fullName = "fullName",
  startDate = "startDate",
  endDate = "endDate",
  fullText = "fullText"
}
